import React from "react";
import { Link } from "react-router-dom";
import { useLanguageContext } from "../../context/LanguageContext";

const Redrafts: React.FC = () => {
  const { isHE } = useLanguageContext();

  const cardClass =
    "group relative flex flex-col rounded-2xl border border-white/10 bg-[#191C22] p-5 shadow-elevation ring-1 ring-white/5";

  return (
    <div className="min-h-screen bg-terminal p-6" dir={isHE ? "rtl" : "ltr"}>
      <div className="mx-auto max-w-3xl">
        <h1
          className="text-2xl font-bold mb-2"
          style={{ color: "#F88158" }}
        >
          {isHE ? "רי-דראפטים" : "Redrafts"}
        </h1>
        <p className="text-sm text-gray-300 mb-8">
          {isHE
            ? "מבט חוזר על מחזורי דראפט מהעבר, כפי שהם נראים היום."
            : "A second look at past NBA Draft classes, ranked with the benefit of hindsight."}
        </p>

        <div className="grid gap-4 sm:grid-cols-2">
          <Link
            to="/redrafts/jaylen-brown-2016-redraft"
            className={`${cardClass} overflow-hidden transition hover:bg-[#1E222A] hover:ring-white/15 active:scale-[0.99]`}
          >
            <img
              src="/assets/2016-redraft.png"
              alt=""
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-20"
            />
            <span className="relative z-10 text-lg font-semibold text-gray-100 transition group-hover:text-white">
              {isHE
                ? "בחינה מחדש של ג'יילן בראון וחברי דראפט 2016"
                : "Re-evaluating Jaylen Brown and his 2016 Draft peers"}
            </span>
            <span
              className="relative z-10 mt-3 inline-flex w-fit items-center rounded-full px-3 py-1 text-xs font-medium text-white"
              style={{ backgroundColor: "#F88158" }}
            >
              {isHE ? "קראו את המאמר" : "read the article"}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Redrafts;
